/**
 * Enum presenting the extraction results.
 */
// -- eslint doesn't understand enums properly.
export var ExtractResult;
(function (ExtractResult) {
    ExtractResult[ExtractResult["COMPLETE"] = 0] = "COMPLETE";
    ExtractResult[ExtractResult["INCOMPLETE"] = 1] = "INCOMPLETE";
    ExtractResult[ExtractResult["SYNTAX_ERROR"] = 2] = "SYNTAX_ERROR";
    ExtractResult[ExtractResult["MISSING_TYPE"] = 3] = "MISSING_TYPE";
    ExtractResult[ExtractResult["INVALID_STEP"] = 4] = "INVALID_STEP";
})(ExtractResult || (ExtractResult = {}));
